import { useEffect } from 'react';
import audioManager from './AudioManager';

const useInterfaceSounds = () => {
  useEffect(() => {
    // Initialize audio manager
    const initAudio = async () => {
      try {
        if (!audioManager.isInitialized()) {
          await audioManager.init();
        }
      } catch (error) {
        console.error('Failed to initialize audio:', error);
      }
    };

    initAudio();

    const handleMouseOver = (event) => {
      // Check if event and target exist
      if (!event || !event.target) return;

      const target = event.target;
      
      // Check if the hovered element is a button or has role="button"
      if (
        (target.tagName && target.tagName.toLowerCase() === 'button') ||
        target.getAttribute('role') === 'button'
      ) {
        audioManager.playHover();
      }
    };

    const handleClick = (event) => {
      // Check if event and target exist
      if (!event || !event.target) return;

      const target = event.target;
      
      // Check if the clicked element is a button or has role="button"
      if (
        (target.tagName && target.tagName.toLowerCase() === 'button') ||
        target.getAttribute('role') === 'button'
      ) {
        audioManager.playSelect();
      }
    };

    // Add global event listeners
    document.addEventListener('mouseover', handleMouseOver, true);
    document.addEventListener('click', handleClick, true);

    // Cleanup
    return () => {
      document.removeEventListener('mouseover', handleMouseOver, true);
      document.removeEventListener('click', handleClick, true);
    };
  }, []);
};

export default useInterfaceSounds;